import { useContext } from "react";

import { DeviceInfoContext } from "../DeviceInfoProvider";

type UseScreenSizeReturn = {
  isLargeOrXlarge: boolean;
  isSmallOrMedium: boolean;
  screenSize: string;
};

/**
 * Hook used to expose the screen size provided by the DeviceInfoContext.
 */

export const useScreenSize = (): UseScreenSizeReturn => {
  const { isLargeOrXlarge, isSmallOrMedium, screenSize } = useContext(DeviceInfoContext) as {
    isLargeOrXlarge: boolean;
    isSmallOrMedium: boolean;
    screenSize: string;
  };

  return {
    isLargeOrXlarge,
    isSmallOrMedium,
    screenSize,
  };
};
